export const ENHANCE_COMMENT = "app/AISlice/ENHANCE_COMMENT";
export const ENHANCE_COMMENT_SUCCESS = "app/AISlice/ENHANCE_COMMENT_SUCCESS";
export const ENHANCE_COMMENT_FAILURE = "app/AISlice/ENHANCE_COMMENT_FAILURE";

export const ENHANCE_FEED = "app/AISlice/ENHANCE_FEED";
export const ENHANCE_FEED_SUCCESS = "app/AISlice/ENHANCE_FEED_SUCCESS";
export const ENHANCE_FEED_FAILURE = "app/AISlice/ENHANCE_FEED_FAILURE";

export const KUDOS_AI_SUGGEST = "app/AISlice/KUDOS_AI_SUGGEST";
export const KUDOS_AI_SUGGEST_SUCCESS = "app/AISlice/KUDOS_AI_SUGGEST_SUCCESS";
export const KUDOS_AI_SUGGEST_FAILURE = "app/AISlice/KUDOS_AI_SUGGEST_FAILURE";

export const FEEDBACK_AI_ENHANCE = "app/AISlice/FEEDBACK_AI_ENHANCE";
export const FEEDBACK_AI_ENHANCE_SUCCESS =
  "app/AISlice/FEEDBACK_AI_ENHANCE_SUCCESS";
export const FEEDBACK_AI_ENHANCE_FAILURE =
  "app/AISlice/FEEDBACK_AI_ENHANCE_FAILURE";
